import React from 'react';
import { LogoUploader } from 'swag-client-common/components/logo-uploader';
import Image from 'swag-client-common/components/ui/image';
import BoxDetailsBlock from '../box-details-block';
import BottomButtons from '../bottom-buttons';
import classes from './brown-box-selection.scss';
export default function BrownBoxSelection(props) {
  const {
    onBackButton,
    selectedBoxData: {
      pricePerBox,
      assemblyFee,
      productionTimeDays,
      img,
      name,
      description,
      additionalProductionTimeText,
      type
    },
    tapeData: {
      img: tapeImg,
      name: tapeName
    },
    uploadedLogo,
    isLoading,
    isBoxTypeEdit,
    onNext,
    uploadBrownBoxLogo
  } = props;
  const handleLogoChange = e => {
    if (e.target.files) {
      const file = e.target.files[0];
      const fileReader = new FileReader();
      fileReader.onload = () => {
        uploadBrownBoxLogo(file);
      };
      fileReader.readAsDataURL(file);
    }
    e.preventDefault();
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.wrapper
  }, /*#__PURE__*/React.createElement("h1", {
    className: classes.title
  }, "Upload your logo for your custom tape!"), /*#__PURE__*/React.createElement("div", {
    className: classes.subTitle
  }, "After you place your order, we will create you a virtual mock-up to approve before we go into production. Don\u2019t worry, you can edit this later!"), /*#__PURE__*/React.createElement(BoxDetailsBlock, {
    pricePerBox: pricePerBox,
    assemblyFee: assemblyFee,
    productionTimeDays: productionTimeDays,
    previewImage: img,
    name: name,
    description: description,
    additionalProductionTimeText: additionalProductionTimeText,
    selectedBoxDataType: type
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.customizeBlock
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.tapeBlock
  }, /*#__PURE__*/React.createElement(Image, {
    src: tapeImg,
    alt: tapeName,
    wrapperClassName: classes.imageWrapper,
    className: classes.image
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.logoUploader
  }, /*#__PURE__*/React.createElement(LogoUploader, {
    isLoading: isLoading,
    logoBlockClassName: classes.logoBlock,
    handleLogoChange: handleLogoChange,
    buttonText: uploadedLogo ? 'Change' : 'Upload your logo',
    currentLogo: uploadedLogo
  }))), /*#__PURE__*/React.createElement(BottomButtons, {
    nextText: isBoxTypeEdit ? 'Save' : 'Continue',
    onBackButton: onBackButton,
    isDisabledNextButton: !uploadedLogo || isLoading,
    isDisabledBackButton: isLoading,
    onNextButton: () => onNext({
      isEditMode: isBoxTypeEdit
    })
  }));
}